<div class="tag-card" [hidden]="hide || !tags.length" #card>
    <mat-chip-set class="mr-8 py-8 wrap">
        <mat-chip
            *ngFor="let tag of tags"
            (click)="filterByTag(tag); $event.stopPropagation()"
            class="pointer"
            [style.background]="tag.color"
            [disableRipple]="true"
        >
            {{ tag.name }}
        </mat-chip>
    </mat-chip-set>
</div>

